

export default {
  ERROR: 0,
  QUEUED: 1,
  RUNNING: 2,
  COMPLETE: 3
};
